<template>
  <div style="height: 100%;overflow: auto;">
    <div class="mb-20">
      <el-input v-model="keyword.name" size="small" clearable placeholder="申请人" class="w-200 mr-20"></el-input>
      <el-select size="small" class="mr-20" v-model="keyword.vip_type" clearable placeholder="请选择套餐">
        <template v-for="(item,key) in class_list">
          <el-option :value="key+1" :label="item.title" :key="key">{{item.title}}</el-option>
        </template>
      </el-select>
      <el-select size="small" class="mr-20" v-model="keyword.is_pay" clearable placeholder="支付状态">
        <el-option value="0" label="未支付">未支付</el-option>
        <el-option value="1" label="已支付">已支付</el-option>
      </el-select>
      <el-date-picker
          v-model="keyword.date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期" class="mr-20" size="small">
      </el-date-picker>
      <el-button type="primary" size="small" @click="search">搜索</el-button>
    </div>
    <el-table :data="list" border stripe>
      <el-table-column label="ID" prop="id" width="80px"></el-table-column>
      <el-table-column label="绑定微信用户">
        <template v-slot="scope">
          <div class="wx-user" v-if="scope.row.user">
            <div class="avatarurl" :style="{ backgroundImage:'url('+scope.row.user.avatarurl+')' }"></div>
            <div class="nickname">{{scope.row.user.nickname}}</div>
          </div>
          <div class="wx-user" v-if="!scope.row.user">
            暂无绑定用户
          </div>
        </template>
      </el-table-column>
      <el-table-column label="申请人" prop="name"></el-table-column>
      <el-table-column label="手机号码" prop="phone"></el-table-column>
      <el-table-column label="地址" prop="">
        <template slot-scope="scope"> {{scope.row.city}}{{scope.row.address}} </template>
      </el-table-column>
<!--      <el-table-column label="是否会员" prop="">
        <template v-slot="scope">
          <el-tag type="success" size="small" v-if="scope.row.is_vip==1" class="mr-10">是</el-tag>
          <el-tag type="info" size="small" v-if="scope.row.is_vip==0" class="mr-10">否</el-tag>
          <template >
            <el-popconfirm title="确定操作？" @confirm="set_vip(scope.row.id,'0')" v-if="scope.row.is_vip==1">
              <el-button slot="reference" type="text" size="small" class="ml-10">取消</el-button>
            </el-popconfirm>
            <el-popconfirm title="确定操作？" @confirm="set_vip(scope.row.id,'1')" v-if="scope.row.is_vip==0">
              <el-button type="text" size="small" slot="reference" class="ml-10">设置</el-button>
            </el-popconfirm>
          </template>
        </template>
      </el-table-column>-->
      <el-table-column label="次数" prop="use_num"></el-table-column>
      <el-table-column label="已用容量" prop="media_size">
        <template v-slot="scope" >
          {{scope.row.media_size}}M
        </template>
      </el-table-column>
      <el-table-column label="套餐" prop="">
        <template v-slot="scope" >
          <div v-if="scope.row.is_vip>0">
            {{scope.row.recharge.title}}
            <el-button class="ml-10" type="text" @click="set_class(scope.row,'change','变更')">变更</el-button>
            <el-button type="text" @click="set_class(scope.row,'renew','续费')">续费</el-button>
          </div>
          <el-button v-else type="text" @click="set_class(scope.row,'setvip','设置')">设置</el-button>
        </template>
      </el-table-column>
      <el-table-column label="到期时间" prop="end_time_format"></el-table-column>
      <el-table-column label="支付状态" prop="is_pay">
        <template v-slot="scope">
          <el-tag type="info" size="small" v-if="scope.row.is_pay==0">未支付</el-tag>
          <el-tag type="success" size="small" v-if="scope.row.is_pay==1">已支付</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="申请时间" prop="addtime_format"></el-table-column>
<!--      <el-table-column label="审核状态" prop="">
        <template v-slot="scope">
          <el-tag type="success" size="small" v-if="scope.row.is_pass==1">通过</el-tag>
          <el-tag type="info" size="small" v-if="scope.row.is_pass==0">未审核</el-tag>
          <el-tag type="danger" size="small" v-if="scope.row.is_pass==2">不通过</el-tag>
          <template>
            <el-popconfirm title="确定审核通过？" @confirm="join_check(scope.row.id,'1',scope.row.uid)"
                           v-if="scope.row.is_pass ==0 || scope.row.is_pass ==2">
              <el-button slot="reference" type="text" size="small" class="ml-10">通过</el-button>
            </el-popconfirm>
            <el-popconfirm title="确定不通过？" @confirm="join_check(scope.row.id,'2',scope.row.uid)"
                           v-if="scope.row.is_pass ==0 || scope.row.is_pass ==1">
              <el-button type="text" size="small" slot="reference" class="ml-10">不通过</el-button>
            </el-popconfirm>
          </template>
        </template>
      </el-table-column>-->
      <el-table-column label="操作" width="120">
        <template v-slot="scope">
<!--          <el-button type="primary" @click="admin_edit(scope.row.id)" size="small" style="margin-right: 10px;">编辑</el-button>-->
          <el-popconfirm title="确认删除？" @confirm="join_del(scope.row.id)">
            <el-button type="danger" size="small" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 60px;"></div>
    <layer-page :total="total" :currentPage="page" @change="page_change"></layer-page>
    <el-dialog :title="'套餐'+tip" :visible.sync="visible" :modal="false" width="30%">
      <el-form label-width="100px">
        <el-form-item label="申请人">
          <el-input disabled :value="info.name" class="w-200"></el-input>
        </el-form-item>
        <el-form-item label="原套餐">
          <el-input disabled :value="info.recharge.title" class="w-200"></el-input>
        </el-form-item>
        <el-form-item label="选择套餐">
          <el-select class="w-200" v-model="vip_type" clearable placeholder="请选择套餐">
            <template v-for="(item,key) in class_list">
              <el-option :value="key" :label="item.title" :key="key">{{item.title}}</el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="confirm">确认{{ tip }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import LayerPage from "@/components/layer-page";
export default {
name: "join",
  components:{LayerPage},
  data(){
    return{
      list:[],
      class_list:[],
      is_load:false,
      page:1,
      total:0,
      keyword:{name:''},
      visible:false,
      info: {recharge:''},
      tip:'',
      vip_type:''
    }
  },
  async mounted(){
    try{
      await this.get_list();
      await this.get_data();
    }catch (e){
      console.log(e);
      return false;
    }
  },
  methods:{
    get_list:async function(){
      if (!this.is_load){
        this.is_load = true;
        this.$_showLoading();
        let res = await this.$_api.company('get_join_list', {page : this.page,keyword:this.keyword});
        this.is_load = false;
        this.$_hideLoading();
        this.list = res.list;
        this.total = res.total;
      }
    },
    get_data: async function (){
      this.$_showLoading();
      let res = await this.$_api.setting('config',{type:'recharge'});
      this.$_hideLoading();
      if(res.errcode == 0 && res.data.content){
        this.class_list = res.data.content.class;
      }
    },
    search:function (){
      this.page = 1;
      this.list = [];
      this.get_list();
    },
    set_class:function (info,method,tip){
      this.info = info;
      this.method = method;
      this.tip = tip;
      this.visible = true;
    },
    confirm:async function (){
      let post = {
        is_vip:this.vip_type+1,
        recharge:this.class_list[this.vip_type],
        id:this.info.id,
      }
      if(!post.recharge){
        this.$_showToastWarning('请选择套餐');
        return;
      }
      if(this.info.is_vip == post.is_vip){
        this.$_showToastWarning('选择套餐一样');
        return;
      }
      this.$_showLoading();
      let res = await this.$_api.join(this.method,post);
      this.$_hideLoading();
      this.$_showToast(res.errmsg,res.style);
      if(res.errcode == 0){
        this.get_list();
        this.visible = false;
      }
    },
    page_change : async function  (e){
      try{
        this.page = e;
        this.is_load = false;
        this.list = [];
        await this.get_list();
      }catch (e){
        console.log(e);
        return false;
      }
    },
    join_check:async function (id,val,uid){
      try {
        this.$_showLoading();
        let res = await this.$_api.company('check',{id : id, val:val,uid:uid});
        this.$_hideLoading();
        this.$_showToast(res.errmsg,res.style);
        if(res.errcode == 0){
          await this.get_list();
        }
      }catch (e){
        console.log(e);
      }
    },
    join_del:async function (id){
      try {
        if (id) {
          this.$_showLoading();
          let res = await this.$_api.company('join_del', { id: id });
          this.$_hideLoading();
          this.$_showToast(res.errmsg,res.style);
          if (res.errcode == 0) {
            await this.get_list();
          }
        }
      }catch (e) {
        console.log(e);
      }
    }
  }
}
</script>

<style scoped>
.wx-user { display: flex; height: 30px; overflow-x: hidden; vertical-align: middle; line-height: 30px; }
.avatarurl { width: 30px; height: 30px; border-radius: 20px; overflow-x: hidden; background: #f2f2f2 no-repeat center; background-size: cover; }
.nickname { padding-left: 15px; font-size: 14px; line-height: 30px;flex: 1 }
</style>